@if (type() === 'card') {
    @for (_ of [].constructor(count()); track $index) {
        <div
            class="space-y-3 rounded-xl border border-gray-100 bg-white p-4 dark:border-gray-700 dark:bg-gray-800">
            <p-skeleton width="100%" height="120px" borderRadius="8px" />
            <p-skeleton width="70%" height="16px" />
            <p-skeleton width="50%" height="12px" />
            <p-skeleton width="40%" height="12px" />
        </div>
    }
} @else if (type() === 'list') {
    @for (_ of [].constructor(count()); track $index) {
        <div class="flex items-center gap-3 py-3">
            <p-skeleton width="48px" height="48px" borderRadius="8px" />
            <div class="flex-1 space-y-2">
                <p-skeleton width="60%" height="14px" />
                <p-skeleton width="40%" height="12px" />
            </div>
        </div>
    }
} @else if (type() === 'circle') {
    <div class="flex gap-3">
        @for (_ of [].constructor(count()); track $index) {
            <p-skeleton width="56px" height="56px" borderRadius="50%" />
        }
    </div>
}
